import { createMuiTheme } from '@material-ui/core/styles';

const defaultTheme = createMuiTheme();
export const theme = createMuiTheme({
    typography: {
    h1Large: {
        fontFamily: 'eirsans-bold',
        fontWeight: 'inherit',
        fontSize: '3.375rem',
        lineHeight: '3.875rem',
        '@media (max-width: 600px)': {
            fontSize: '2.331rem',
            lineHeight: '2.831rem',
        },
    },
    h1: {
        fontFamily: 'eirsans-bold',
        fontWeight: 'inherit',
        fontSize: '2.5rem',
        lineHeight: '3rem',
        '@media (max-width: 600px)': {
            fontSize: '1.726rem',
            lineHeight: '2.225rem',
        },
    },
    h2Large: {
        fontFamily: 'eirsans-bold',
        fontWeight: 'inherit',
        fontSize: '3.375rem',
        lineHeight: '3.875rem',
        '@media (max-width: 600px)': {
            fontSize: '2.331rem',
            lineHeight: '2.831rem',
        },
    },
    h2: {
        fontFamily: 'eirsans-bold',
        fontWeight: 'inherit',
        fontSize: '2rem',
        lineHeight: '2.5rem',
        '@media (max-width: 600px)': {
            fontSize: '1.536rem',
            lineHeight: '2.038rem',
        },
    },
    h3: {
        fontFamily: 'eirsans-bold',
        fontWeight: 'inherit',
        fontSize: '1.75rem',
        lineHeight: '2.25',
        '@media (max-width: 600px)': {
            fontSize: '1.441rem',
            lineHeight: '1.938rem',
        },
    },
    h4: {
        fontFamily: 'eirsans-bold',
        fontWeight: 'inherit',
        fontSize: '1.5rem',
        lineHeight: '2rem',
        '@media (max-width: 600px)': {
            fontSize: '1.345rem',
            lineHeight: '1.844rem',
        },
    },
    h5: {
        fontFamily: 'eirsans-bold',
        fontWeight: 'inherit',
        fontSize: '1.25rem',
        lineHeight: '1.75rem',
        '@media (max-width: 600px)': {
            fontSize: '1.25rem',
            lineHeight: '1.75rem',
        },
    },
    h6: {
        fontFamily: 'eirsans-bold',
        fontWeight: 'inherit',
        fontSize: '1rem',
        lineHeight: '1.5rem',
        '@media (max-width: 600px)': {
            fontSize: '1rem',
            lineHeight: '1.5rem',
        },
    },

    subtitle1: {
        fontFamily: 'eirsans-bold',
        fontWeight: 'inherit',
        fontSize: '1rem',
        lineHeight: '1.5rem',
        '@media (max-width: 600px)': {
            fontSize: '1rem',
            lineHeight: '1.5rem',
        },
    },
    subtitle2: {
        fontFamily: 'eirsans-bold',
        fontWeight: 'inherit',
        fontSize: '0.875rem',
        lineHeight: '1.375rem',
        '@media (max-width: 600px)': {
            fontSize: '0.875rem',
            lineHeight: '1.375rem',
        },
    },

    body1: {
        fontFamily: 'eirsans-light',
        fontWeight: 'inherit',
        fontSize: '1rem',
        lineHeight: '1.5rem',

        '@media (max-width: 600px)': {
            fontSize: '1rem',
            lineHeight: '1.5rem',
        },
    },
    body2: {
        fontFamily: 'eirsans-light',
        fontWeight: 'inherit',
        fontSize: '0.875rem',
        lineHeight: '1.375rem',
        '@media (max-width: 600px)': {
            fontSize: '0.875rem',
            lineHeight: '1.375rem',
        },
    },
    body3: {
        fontFamily: 'eirsans-light',
        fontWeight: 'inherit',
        fontSize: '1.125rem',
        lineHeight: '1.625rem',
        '@media (max-width: 600px)': {
            fontSize: '1.125rem',
            lineHeight: '1.625rem',
        },
    },
    body3Medium: {
        fontFamily: 'eirsans-regular',
        fontWeight: 'inherit',
        fontSize: '1.125rem',
        lineHeight: '1.625rem',
        '@media (max-width: 600px)': {
            fontSize: '1.125rem',
            lineHeight: '1.625rem',
        },
    },

    caption: {
        fontFamily: 'eirsans-light',
        fontWeight: 'inherit',
        fontSize: '0.813rem',
        lineHeight: '1.25rem',
        '@media (max-width: 600px)': {
            fontSize: '1rem',
            lineHeight: '1.5rem',
        },
    },
    overline: {
        fontFamily: 'eirsans-light',
        fontWeight: 'inherit',
        fontSize: '0.75rem',
        lineHeight: '1.375rem',
        '@media (max-width: 600px)': {
            fontSize: '0.75rem',
            lineHeight: '1.375rem',
        },
    },

    avatarLetter: {
        fontFamily: 'eirsans-light',
        fontWeight: 'inherit',
        fontSize: '1.25rem',
        lineHeight: '1.75rem',
        '@media (max-width: 600px)': {
            fontSize: '1.25rem',
            lineHeight: '1.75rem',
        },
    },
    inputLabel: {
        fontFamily: 'eirsans-light',
        fontWeight: 'inherit',
        fontSize: '0.75rem',
        lineHeight: '0.75rem',
        '@media (max-width: 600px)': {
            fontSize: '0.75rem',
            lineHeight: '0.75rem',
        },
    },
    helperText: {
        fontFamily: 'eirsans-light',
        fontWeight: 'inherit',
        fontSize: '0.875rem',
        lineHeight: '1.375rem',
        '@media (max-width: 600px)': {
            fontSize: '0.875rem',
            lineHeight: '1.375rem',
        },
    },
    inputText: {
        fontFamily: 'eirsans-light',
        fontWeight: 'inherit',
        fontSize: '1rem',
        lineHeight: '1.5rem',
        '@media (max-width: 600px)': {
            fontSize: '1rem',
            lineHeight: '1.5rem',
        },
    },

    tooltip: {
        fontFamily: 'eirsans-regular',
        fontWeight: 'inherit',
        fontSize: '0.625rem',
        lineHeight: '1.125rem',
        '@media (max-width: 600px)': {
            fontSize: '0.625rem',
            lineHeight: '1.125rem',
        },
    },
    },
    palette: {
        primary: {
            main: '#493553',
        },
        secondary: {
            main: '#D111C9',
        },
    },
    overrides: {
        MuiTooltip: {
            tooltip: {
                fontSize: '14',
            },
        },
        MuiFormLabel: {
            asterisk: {
                color: '#f44336;',
            },
        },
        MuiStepper: {
            root: {
                backgroundColor: '#ECECEC',
                paddingLeft: '7%',
                height: '60px',
                paddingRight: '7%',
                [defaultTheme.breakpoints.down('xs')]: {
                    paddingLeft: '3%',
                    paddingRight: '3%',
                },
                '@media (max-width:1024px)': {
                    height: '70px',
                },
            },
        },
        MuiStepLabel: {
            label: {
                fontFamily: 'gt-walsheim-medium',
                fontSize: 16,
                '@media (max-width:768px)': {
                    marginTop: '25px !important',
                },
                '&$active': {
                    color: '#493553',
                },
                '&$completed': {
                    color: '#493553',
                },
                [defaultTheme.breakpoints.down('xs')]: {
                    fontSize: 13,
                },
            },
        },
    },
});
